const theme = {
  prefix: "default"
}

export default theme
